export default {
    methods: {
        triggerRemoveNavActiveEl() {
            this.$root.removeActiveEl();
        }
    }
};
